export const clampLeadMatchScore = (score) => {
    const value = Number(score);
    if (!Number.isFinite(value)) return null;
    return Math.min(100, Math.max(0, Math.round(value)));
};

export const getLeadMatchQualityTier = (score) => {
    const value = clampLeadMatchScore(score);
    if (value === null) return null;

    if (value >= 66) {
        return { level: 'high', value };
    }
    if (value >= 36) {
        return { level: 'medium', value };
    }
    return { level: 'low', value };
};
